/* eslint-disable react/jsx-pascal-case */
import { allPossibleZoneUrto, ZonaUrtoEnum, ZoneUrtoType } from "../../types/communication/communicationDataType"
import { Trct_CarUrtoContainer, Trct_UrtoBkImg, Trct_UrtoTable } from "../styled/ZonaUrto_Trct.style"
import Trtc_UrtoTableCellCmp from "./Trtc_UrtoTableCellCmp";

import damageLocationCarBlue from './../../assets/svg/damage-location-car-blue.svg'
import damageLocationCarYellow from './../../assets/svg/damage-location-car-yellow.svg'
import { PATHS } from "../../routes/CaiExperienceRouter";

interface Trtc_ZoneUrtoCmpProps {
    zoneUrto: ZoneUrtoType[];
    setZoneUrto: any;
    isMainImpactPoint?: boolean;
    mainImpactPoint?: ZonaUrtoEnum;
    path?: string;
}

/* istanbul ignore next */
const Trtc_ZoneUrtoCmp = (props: Trtc_ZoneUrtoCmpProps) => {
    const { zoneUrto, setZoneUrto, isMainImpactPoint, mainImpactPoint, path } = props
    const whichCar = path && [PATHS.TRCT_CTP_MAIN_ZONE_URTO_VEICOLO, PATHS.TRCT_CTP_ZONE_URTO_VEICOLO].includes(path) ? damageLocationCarYellow : damageLocationCarBlue

    const addZoneHandler = (zu: Partial<ZoneUrtoType>) => {
        if (isMainImpactPoint === true) {
            setZoneUrto([new ZoneUrtoType({ position: zu.position, isSelected: true })]);
        }
        else {
            setZoneUrto((zones: ZoneUrtoType[]) => {
                if (zones.find(z => z.position === zu.position)) {
                    return [...zones]
                } else {
                    return [...zones, new ZoneUrtoType({ position: zu.position, isSelected: true })]
                }
            })
        }
    }

    const removeZoneHandler = (zu: ZoneUrtoType) => {
        setZoneUrto((zones: ZoneUrtoType[]) => {
            return zones.filter(z => z.position !== zu.position)
        })
    }

    return (
        <>
            <Trct_CarUrtoContainer>
                <Trct_UrtoBkImg src={whichCar} alt={whichCar} />

                <Trct_UrtoTable>
                    {allPossibleZoneUrto.map((zu: Partial<ZoneUrtoType>) => {
                        const zoneItem = zoneUrto.find(z => z.position === zu.position)
                        const currZoneItem = zoneItem || zu
                        return (
                            <Trtc_UrtoTableCellCmp
                                mainImpactPoint={mainImpactPoint}
                                isMainImpactPoint={isMainImpactPoint}
                                key={currZoneItem.position}
                                zoneItem={currZoneItem}
                                addZone={() => addZoneHandler(currZoneItem)}
                                removeZone={() => removeZoneHandler(currZoneItem)}
                                position={zu.position}
                                excludePositions={[ZonaUrtoEnum["CENTER-CENTER"]]} />
                        )
                    }
                    )}

                </Trct_UrtoTable>
            </Trct_CarUrtoContainer>
        </>
    )
}

export default Trtc_ZoneUrtoCmp